import { useIntersectionObserver } from '@uidotdev/usehooks'
import { FC, PropsWithChildren, useEffect, useRef } from 'react'

import { useAdvanceContentContext } from './hooks/useAdvanceContentContext'
import { TakeAdvanceContentBody } from './styles'

export const TakeAdvanceContent: FC<PropsWithChildren> = ({ children }) => {
  const { setContentOverflow } = useAdvanceContentContext()
  const scrollContainerRef = useRef<HTMLDivElement>(null)

  const [bottomRef, bottomEntry] = useIntersectionObserver({
    threshold: 1,
    rootMargin: '0px 0px 0px 0px',
    root: scrollContainerRef.current,
  })

  useEffect(() => {
    if (bottomEntry?.isIntersecting) {
      setContentOverflow(false)
    } else {
      setContentOverflow(true)
    }
  }, [bottomEntry?.isIntersecting, setContentOverflow])

  return (
    <TakeAdvanceContentBody ref={scrollContainerRef}>
      {children}
      <div data-scroll-watcher ref={bottomRef} />
    </TakeAdvanceContentBody>
  )
}
